import { TFunction } from "i18next";
import { z } from "zod";

/**
 * Schema for the stepper form
 * Note: sharedReason validation is handled manually in handleNext
 * to check if all organizations have individual reasons
 */
export const createStepperFormSchema = (t: TFunction) =>
  z.object({
    organizations: z
      .array(
        z.object({
          organizationId: z.number(),
          reason: z.string(),
        })
      )
      .min(1, {
        message: t("modals:updateparticipantsstepperform.validation.atleastone"),
      }),
    sharedReason: z.string().optional(),
  });

export type StepperFormData = z.infer<ReturnType<typeof createStepperFormSchema>>;
